import Immutable from 'immutable';
import settings from '../settings.json';

const thalamusRegions = settings.regionList;

const initialState = Immutable.Map({
  chosen: Immutable.OrderedSet(thalamusRegions),
  order: 'grouped', // alternative is alpha
});

function addChosen(state, items) {
  let current = state.get('chosen');
  current = current.merge(items);
  return state.set('chosen', current);
}

function removeChosen(state, items) {
  let current = state.get('chosen');
  current = current.subtract(items);
  return state.setIn(['chosen'], current);
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CHOSEN':
      return state.set('chosen', Immutable.OrderedSet(action.json));
    case 'REMOVE_CHOSEN':
      return removeChosen(state, action.json);
    case 'ADD_CHOSEN':
      return addChosen(state, action.json);
    case 'SET_ORDER':
      return state.set('order', action.json);
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/cell_population.js